import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { Router } from '@angular/router';
import { EmpresaService } from '../../core/services/empresa.service';
import { MenuService } from '../../core/services/menu.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  isMenuOpen$: Observable<boolean>;
  isVendaMenuOpen = false;
  isEstoqueMenuOpen = false;
  isAssinaturaMenuOpen = false; // Controle do submenu de assinaturas
  currentUser: any;
  empresaNome: string | null = null;
  empresaTelefone: string | null = null;
  isMaster: boolean = false;

  constructor(
    public authService: AuthService,
    private readonly router: Router,
    private readonly empresaService: EmpresaService,
    private menuService: MenuService
  ) {
    this.isMenuOpen$ = this.menuService.menuOpen$;
  }

  ngOnInit(): void {
    this.authService.currentUser$.subscribe((user) => {
      this.currentUser = user;
      try {
        this.isMaster = this.authService.hasRole('MASTER');
      } catch {
        this.isMaster = false;
      }
      this.loadEmpresaNome();
    });

    this.authService.ensureUserLoaded(10000).subscribe((u) => {
      try {
        this.isMaster = this.authService.hasRole('MASTER');
      } catch {
        this.isMaster = false;
      }
    });
  }

  hasMaster(): boolean {
    return this.isMaster;
  }

  private loadEmpresaNome(): void {
    const empresaId = this.authService.getEmpresaId();
    if (!empresaId) {
      this.empresaNome = null;
      this.empresaTelefone = null;
      return;
    }

    this.empresaService.obterPorTenant(empresaId).subscribe({
      next: (empresa) => {
        this.empresaNome = empresa?.nomeRazao || null;
        this.empresaTelefone = empresa?.celular || empresa?.telefone || null;
      },
      error: (err) => {
        console.warn('Não foi possível obter empresa do token/tenant:', err);
        this.empresaNome = null;
        this.empresaTelefone = null;
      },
    });
  }

  toggleVendaMenu(event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    this.isVendaMenuOpen = !this.isVendaMenuOpen;
  }

  toggleEstoqueMenu(event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    this.isEstoqueMenuOpen = !this.isEstoqueMenuOpen;
  }

  toggleAssinaturaMenu(event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    this.isAssinaturaMenuOpen = !this.isAssinaturaMenuOpen;
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
